// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwWidget from 'viewmodel/AwWidgetViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "projectsListBox": {
      "displayName": "{{i18n.projects}}",
      "name": "projectsListBox",
      "type": "STRING",
      "dataProvider": "listProjectsAsListboxDataProvider",
      "dbValue": "",
      "placeholder": "Enter text to search"
    },
    "selectedProject": {},
    "details": {},
    "projectsSkip": 0
  },
  "dataProviders": {
    "listProjectsAsListboxDataProvider": {
      "initializeAction": "fetchProjectsListAsListboxwithBaseVals",
      "nextAction": "fetchProjectsListAsListbox",
      "response": "{{projects}}",
      "totalFound": "{{totalCount}}"
    }
  },
  "actions": {
    "fetchProjectsListAsListboxwithBaseVals": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query listProjectsAsListbox( $getProjectsInput: GetProjectsInput ) { listProjectsAsListbox( getProjectsInput: $getProjectsInput) { error items totalCount skip}}",
            "variables": {
              "getProjectsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "filterString": "{{data.projectsListBox.filterString}}",
                "skip": 0,
                "totalCount": 0,
                "roleFilters": "{{props.roleFilters}}",
                "ownershipFilters": "{{props.ownershipFilters}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "projectsAsListBox": "data.data.listProjectsAsListbox",
        "projects": "data.data.listProjectsAsListbox.items",
        "projectsSkip": "data.data.listProjectsAsListbox.skip",
        "totalCount": "data.data.listProjectsAsListbox.totalCount"
      },
      "events": {
        "success": [{
          "condition": "projectsAsListBox.error === 'EMPTY_COLLAB_SPACE'",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 400 || errorCode === 400",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.BAD_REQUEST_GET_PROJECTS}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 403 || errorCode === 403",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.FORBIDDEN_GET_PROJECTS}}",
            "errorCode": 403
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode >= 500 && projectsAsListBox.error.statusCode <= 599",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "actionMessages": {},
      "deps": "js/accHttpService"
    },
    "fetchProjectsListAsListbox": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query listProjectsAsListbox( $getProjectsInput: GetProjectsInput ) { listProjectsAsListbox( getProjectsInput: $getProjectsInput) { error items totalCount skip}}",
            "variables": {
              "getProjectsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "filterString": "{{data.projectsListBox.filterString}}",
                "totalCount": "{{data.dataProviders.listProjectsAsListboxDataProvider.startIndex}}",
                "skip": "{{data.projectsSkip}}",
                "roleFilters": "{{props.roleFilters}}",
                "ownershipFilters": "{{props.ownershipFilters}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "projectsAsListBox": "data.data.listProjectsAsListbox",
        "projects": "data.data.listProjectsAsListbox.items",
        "projectsSkip": "data.data.listProjectsAsListbox.skip",
        "totalCount": "data.data.listProjectsAsListbox.totalCount"
      },
      "events": {
        "success": [{
          "condition": "projectsAsListBox.error === 'EMPTY_COLLAB_SPACE'",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 400 || errorCode === 400",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.BAD_REQUEST_GET_PROJECTS}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 403 || errorCode === 403",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.FORBIDDEN_GET_PROJECTS}}",
            "errorCode": 403
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "projectsAsListBox.error.statusCode >= 500 && projectsAsListBox.error.statusCode <= 599",
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "projectsAsListBox.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "actionMessages": {},
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "conditions": {
    "validInput": {
      "expression": "props.accsessionid && props.accsessionid.length > 0 && props.collaborationspaceid && props.collaborationspaceid.length > 0"
    }
  },
  "onEvent": [{
    "eventId": "listProjectsAsListboxDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-projects-as-listbox.projectSelected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "listProjectsAsListboxDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-projects-as-listbox.project-selected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "projectsAsListBox.failure",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-projects-as-listbox.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "lifecycleHooks": {
    "onMount": ""
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "role-filters": {
      "type": "string"
    },
    "ownership-filters": {
      "type": "string"
    }
  },
  "i18n": {
    "projects": ["projectMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_GET_PROJECTS": ["errorMessages"],
    "FORBIDDEN_GET_PROJECTS": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "ListProjectsAsListbox",
  "_uniqueViewModelId": "ListProjectsAsListbox",
  "ctx": {}
};

/*
<div class="afx-content-background aw-layout-full">
    <aw-widget prop="data.projectsListBox"></aw-widget>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwWidget, getField("data.projectsListBox", fields, $index, null, null)));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;